import { css } from "@emotion/react"
import { PHOTO_RESOURCE_BASE_URL } from "config"
import { MouseEvent } from "react"
import { PhotoWithIndex } from "type"

type Props = {
  photo: PhotoWithIndex
  isSelected: boolean
  order?: number
  onClick?: (event: MouseEvent<HTMLImageElement>, index: number) =>void
}


export const SelectImageItem = (props: Props)=>{

  const onRawClick = (event: MouseEvent<HTMLImageElement>) =>{
    if (props.onClick === undefined){
      return
    }
    props.onClick(event, props.photo.index)
  }

  return(
    <div onClick={onRawClick}>
      <img
        loading="lazy"
        css={imgCss}
        src={PHOTO_RESOURCE_BASE_URL+'/'+props.photo.filename}
        alt="uploaded"
      />
      {props.isSelected && (
        <div css={overWrapCss}>
          <div>
            {props.order}
          </div>
        </div>
      )}
    </div>
  )
}

const imgCss = css`
  position: absolute;
  width: 100%;
  height: 100%;
  object-fit: cover;
`

const overWrapCss=css`
  display: flex;
  top: 1rem;
  right: 1rem;
  width: 3rem;
  height: 3rem;
  border-radius: 100%;
  position: absolute;
  z-index: 100;
  background-color: dodgerblue;
  font-size: 1.5rem;
  color: white;
  justify-content: center;
  align-items: center;
`